import { useCallback, useEffect, useState } from 'react';
import { Row, Col, Button, Form, Spinner } from 'react-bootstrap';

import SupplyCategories from './SupplyCategories';
import ShippingInfo from './ShippingInfo'
import Header from './Header'
import { MissingDataModal, SuccessModal, ErrorModal } from './Modals'
import config from './config';
import apiFetch from './api';


import 'bootstrap/dist/css/bootstrap.min.css'
import './styles.css'

const email_gql = config.urls.email_url;
const account_url = config.urls.account_url;

function getCookie(cName) {
    const name = cName + "=";
    const cArr = document.cookie.split('; ');
    for (let i = 0; i < cArr.length; i++) {
        if (cArr[i].indexOf(name) === 0) return cArr[i].substring(name.length);
    }
    return undefined;
}

const App = () => {
    const [supplies, setSupplies] = useState([]);
    const [customerInformation, setCustomerInformation] = useState({
        accountNumber: "",
        fullName: "",
        emailName: "",
        address: "",
        city: "",
        state: "",
        zipCode: "",
        phoneNumber: "",
        labLocation: "",
        supplies: ""
    })
    const [missingData, setMissingData] = useState([])
    const [availableAccounts, setAvailableAccounts] = useState([]);
    const [showMissingDataModal, setShowMissingDataModal] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [sendingOrder, setSendingOrder] = useState(false);
    const [userId, setUserId] = useState("");
    const [midWestPMSFeedBags, setMidWestPMSFeedBags] = useState(null)
    const [accountAddress, setAccountAddress] = useState({
        address: "",
        city: "",
        state: "",
        zipCode: ""
    });
    const [userAddress, setUserAddress] = useState({
        address: "",
        city: "",
        state: "",
        zipCode: ""
    });
    const [selectedAddress, setSelectedAddress] = useState("")

    const fetchData = useCallback(async () => {
        try {
            const userName = getCookie("username");

            const suppliesPromise = apiFetch(`${account_url}/api/supplies`).then(res => res.json());
            const accountPromise = (userName !== "" && userName !== undefined)
                ? apiFetch(`${account_url}/api/customers/${userName}`).then(res => res.json())
                : Promise.resolve(null);

            const [suppliesListResponse, accountResponse] = await Promise.all([suppliesPromise, accountPromise]);

            const suppliesList = [...suppliesListResponse];
            const category2 = suppliesList.find(c => c.supplyCategoryID === 2);
            if (category2) {
                const feedSupplies = category2.supplies;
                const idx = feedSupplies.findIndex(s => s.supplyID === 231);
                if (idx !== -1) {
                    setMidWestPMSFeedBags(feedSupplies[idx]);
                    feedSupplies.splice(idx, 1);
                }
            }

            setSupplies(suppliesList)
            if (accountResponse) {
                const customerAccounts = accountResponse[0].accounts || [];
                if (customerAccounts.length < 1) {
                    setAvailableAccounts([])
                } else {
                    setAvailableAccounts(customerAccounts);
                }

                let clientName = "";
                let clientEmail = "";
                let clientStreet = "";
                let clientCity = "";
                let clientState = "";
                let clientZipCode = "";
                let clientPhoneNumber = "";
                if (accountResponse[0].info.length !== 0) {
                    const info = accountResponse[0].info[0];
                    const isValid = val => val !== "" && val !== "&lt;Not Specified&gt;";

                    if (isValid(info.fullName)) clientName = info.fullName;
                    if (isValid(info.email)) clientEmail = info.email;
                    if (isValid(info.street)) clientStreet = info.street;
                    if (isValid(info.city)) clientCity = info.city;
                    if (isValid(info.state)) clientState = info.state;
                    if (isValid(info.postalCode)) clientZipCode = info.postalCode;
                    if (isValid(info.phoneNumber)) clientPhoneNumber = info.phoneNumber;
                    if (isValid(info.userid)) setUserId(info.userid);
                }

                setCustomerInformation(prevState => {
                    return {
                        ...prevState,
                        fullName: clientName,
                        emailName: clientEmail,
                        phoneNumber: clientPhoneNumber
                    }
                });
                setUserAddress({
                    address: clientStreet,
                    city: clientCity,
                    state: clientState,
                    zipCode: clientZipCode,
                })
            }
        } catch (err) {
            console.error('Fetching data failed:', err);
            window.logError(err, 'fetchData')
        }
    }, [])

    const handleUpdateAccountNumber = useCallback(async (e) => {
        if (e && e.preventDefault) e.preventDefault();
        const value = e.target ? e.target.value : e;

        setCustomerInformation(prevState => {
            return { ...prevState, accountNumber: value }
        });

        if (value === "No Accounts Available") {
            setAccountAddress({
                address: "",
                city: "",
                state: "",
                zipCode: ""
            });
            return;
        }

        try {
            const accountAddressFetch = await apiFetch(`${account_url}/api/accounts/${value}/address`);
            const accountAddressResp = await accountAddressFetch.json();
            const street = accountAddressResp.street !== '' ? accountAddressResp.street : accountAddressResp.street2;
            const newAddress = {
                address: street,
                city: accountAddressResp.city,
                state: accountAddressResp.state,
                zipCode: accountAddressResp.zipCode
            };
            setAccountAddress(newAddress);
            setSelectedAddress('accountAd');
            setCustomerInformation(prevState => ({ ...prevState, ...newAddress }));
        } catch (err) {
            console.error('Updating account number failed:', err);
            window.logError(err, 'handleUpdateAccountNumber')
        }
    }, [])

    const handleUpdateContactName = (e) => {
        e.preventDefault();
        const value = e.target.value;
        setCustomerInformation(prevState => {
            return { ...prevState, fullName: value }
        });
    }
    const handleUpdateEmailName = (e) => {
        e.preventDefault();
        const value = e.target.value;
        setCustomerInformation(prevState => {
            return { ...prevState, emailName: value }
        });
    }
    const handleUpdateAddress = (e) => {
        e.preventDefault();
        const value = e.target.value;
        const addressToUse = value.replace(/['"]/g, " ");

        setUserAddress(prevState => ({ ...prevState, address: addressToUse }));
        if (selectedAddress === 'userAd') {
            setCustomerInformation(prevState => ({ ...prevState, address: addressToUse }));
        }
    }
    const handleUpdateCity = (e) => {
        e.preventDefault();
        const value = e.target.value;
        setUserAddress(prevState => {
            return { ...prevState, city: value }
        });
        if (selectedAddress === 'userAd') {
            setCustomerInformation(prevState => {
                return { ...prevState, city: value }
            });
        }
    }
    const handleUpdateState = (e) => {
        e.preventDefault();
        const value = e.target.value;
        setUserAddress(prevState => {
            return { ...prevState, state: value }
        });
        if (selectedAddress === 'userAd') {
            setCustomerInformation(prevState => {
                return { ...prevState, state: value }
            });
        }
    }
    const handleUpdateZipCode = (e) => {
        e.preventDefault();
        const value = e.target.value;
        setUserAddress(prevState => {
            return { ...prevState, zipCode: value }
        });
        if (selectedAddress === 'userAd') {
            setCustomerInformation(prevState => {
                return { ...prevState, zipCode: value }
            });
        }
    }
    const handleUpdatePhoneNumber = (e) => {
        e.preventDefault();
        const value = e.target.value;
        setCustomerInformation(prevState => {
            return { ...prevState, phoneNumber: value }
        });
    }
    const handleUpdateLabLocation = (e) => {
        e.preventDefault();
        const value = e.target.value;
        setCustomerInformation(prevState => {
            return { ...prevState, labLocation: value }
        });
    }

    const handleRadioAddress = useCallback((e) => {
        const accountType = e.target.id;
        setSelectedAddress(accountType);
        if (accountType === 'userAd') {
            const addressToUse = userAddress.address.replace(/['"]/g, " ");
            setCustomerInformation(prevState => ({
                ...prevState,
                address: addressToUse,
                city: userAddress.city,
                state: userAddress.state,
                zipCode: userAddress.zipCode
            }));
        } else {
            setCustomerInformation(prevState => ({
                ...prevState,
                address: accountAddress.address,
                city: accountAddress.city,
                state: accountAddress.state,
                zipCode: accountAddress.zipCode
            }));
        }
    }, [userAddress, accountAddress])

    const handleAddSuppliesForOrder = (e, x, supplyCategory) => {
        const quantity = e && e.target ? parseInt(e.target.value, 10) || 0 : 0;
        const { supplyID, emailName } = x;

        setCustomerInformation(prevState => {
            const currentSupplies = Array.isArray(prevState.supplies) ? prevState.supplies : [];
            const newSupplies = currentSupplies.filter(s => s.supplyID !== supplyID);

            if (quantity > 0) {
                newSupplies.push({ quantity, supplyID, supplyCategory, emailName });
            }

            return { ...prevState, supplies: newSupplies.length > 0 ? newSupplies : "" };
        });
    }

    const handleReset = () => {
        document.getElementById("order-form").reset();
        setSupplies([])
        setCustomerInformation({
            accountNumber: "",
            fullName: "",
            emailName: "",
            address: "",
            city: "",
            state: "",
            zipCode: "",
            phoneNumber: "",
            labLocation: "",
            supplies: ""
        })
        setAccountAddress({
            address: "",
            city: "",
            state: "",
            zipCode: ""
        })
        setUserAddress({
            address: "",
            city: "",
            state: "",
            zipCode: ""
        })
        setSelectedAddress("")
        setMissingData([])
        fetchData()
    }

    const handleSubmit = async () => {
        if (sendingOrder) return;
        let emailToAddress;
        const customerMailTo = customerInformation.emailName;
        if (customerInformation.labLocation === "Dodge City") {
            emailToAddress = 'dodgecitysupplies@servi-techinc.com';
        } else if (customerInformation.labLocation === "Hastings") {
            emailToAddress = 'hastingssupplies@servi-techinc.com';
        } else {
            emailToAddress = 'amarillosupplies@servi-techinc.com';
        }
        const missingInfoList = [];
        if (customerInformation.accountNumber === "" || customerInformation.accountNumber === "No Accounts Available") {
            missingInfoList.push("Account Option Not Selected")
        }
        if (customerInformation.fullName === "") {
            missingInfoList.push("Contact Name Missing")
        }
        if (customerInformation.emailName === "") {
            missingInfoList.push("Email Address Missing")
        }
        if (customerInformation.address === "") {
            missingInfoList.push("Address Missing")
        }
        if (customerInformation.city === "") {
            missingInfoList.push("City Missing")
        }
        if (customerInformation.state === "") {
            missingInfoList.push("State Missing")
        }
        if (customerInformation.zipCode === "") {
            missingInfoList.push("Zip Code Missing")
        }
        if (customerInformation.phoneNumber === "") {
            missingInfoList.push("Phone Number Missing")
        }
        if (customerInformation.labLocation !== 'Dodge City' && customerInformation.labLocation !== 'Amarillo' && customerInformation.labLocation !== 'Hastings') {
            missingInfoList.push("Lab Location Missing")
        }
        if (customerInformation.supplies === "") {
            missingInfoList.push("No supplies were selected")
        }
        if (selectedAddress === "") {
            missingInfoList.push("Please select a \"Ship To\" option")
        }
        setMissingData(missingInfoList)
        if (missingInfoList.length >= 1) {
            setShowMissingDataModal(true);
        } else {
            setSendingOrder(true);
            try {
                const emailQuery = `{sendSupplyOrderEmailFromWebsite(emailTo:${JSON.stringify(emailToAddress)},orderJSON:${JSON.stringify(JSON.stringify(customerInformation))})}`;
                const emailConfirmationQuery = `{sendOrderConfirmationEmail(customerEmail:${JSON.stringify(customerMailTo)},orderJSON:${JSON.stringify(JSON.stringify(customerInformation))})}`;

                const [emailFetch, emailConfirmationFetch, limsOrderFetch] = await Promise.all([
                    fetch(`${email_gql}/graphql`, { method: 'POST', body: JSON.stringify({ query: emailQuery }), headers: { 'Content-Type': 'application/json' } }),
                    fetch(`${email_gql}/graphql`, { method: 'POST', body: JSON.stringify({ query: emailConfirmationQuery }), headers: { 'Content-Type': 'application/json' } }),
                    apiFetch(`${account_url}/api/orders`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(customerInformation)
                    })
                ]);

                const [emailJSON, emailConfirmationJSON, limsOrderJSON] = await Promise.all([
                    emailFetch.json(),
                    emailConfirmationFetch.json(),
                    limsOrderFetch.json()
                ]);

                const emailResponse = emailJSON?.data?.sendSupplyOrderEmailFromWebsite;
                const emailConfirmationResponse = emailConfirmationJSON?.data?.sendOrderConfirmationEmail;
                const limsOrderResponse = limsOrderJSON?.message;

                if (emailResponse === 'email sent' && emailConfirmationResponse === 'email sent') {
                    handleReset()
                    setShowSuccessModal(true)
                    setTimeout(() => setShowSuccessModal(false), 4000)
                } else {
                    console.error('Order submission failed: unexpected response', {
                        orderEmail: { url: emailFetch.url, status: emailFetch.status, ok: emailFetch.ok, body: emailJSON },
                        confirmationEmail: { url: emailConfirmationFetch.url, status: emailConfirmationFetch.status, ok: emailConfirmationFetch.ok, body: emailConfirmationJSON },
                        limsOrder: { url: limsOrderFetch.url, status: limsOrderFetch.status, ok: limsOrderFetch.ok, body: limsOrderJSON }
                    });
                    setShowErrorModal(true)
                }
                if (limsOrderResponse === 'Order Added to LIMS') {
                    const limsEmailQuery = `{sendLIMSOrderConfirmationEmail(emailTo:${JSON.stringify(emailToAddress)},orderJSON:${JSON.stringify(JSON.stringify(customerInformation))})}`
                    await fetch(`${email_gql}/graphql`, { method: 'POST', body: JSON.stringify({ query: limsEmailQuery }), headers: { 'Content-Type': 'application/json' } });
                }
            } catch (err) {
                console.error('Order submission failed:', err, { emailGql: email_gql, accountUrl: account_url });
                window.logError(err, 'handleSubmit')
                setShowErrorModal(true)
            } finally {
                setSendingOrder(false);
            }
        }
    }

    const getCompanySpecificLabels = useCallback(async () => {
        try {
            const customerGroupsForWebUserFetch = await apiFetch(`${account_url}/api/accounts/${userId}/groups`);
            const parsedCustomerGroupsForWebUser = await customerGroupsForWebUserFetch.json();

            if (parsedCustomerGroupsForWebUser.length && parsedCustomerGroupsForWebUser.includes(1223)) {
                setSupplies(prevData =>
                    prevData.map(category =>
                        category.supplyCategory === "Feed Sampling Supplies" ?
                            {
                                ...category,
                                supplies: [...category.supplies, midWestPMSFeedBags]
                            } : category
                    ))
            }
        } catch (err) {
            console.error('Fetching company specific labels failed:', err);
            window.logError(err, 'getCompanySpecificLabels')
        }
    }, [userId, midWestPMSFeedBags])

    useEffect(() => {
        fetchData();
    }, [fetchData])

    useEffect(() => {
        if (availableAccounts.length > 0 && (customerInformation.accountNumber === "" || customerInformation.accountNumber === "No Accounts Available")) {
            handleUpdateAccountNumber({ target: { value: availableAccounts[0].AccountID }, preventDefault: () => {} });
        }
    }, [availableAccounts, customerInformation.accountNumber, handleUpdateAccountNumber])

    useEffect(() => {
        if (userId && midWestPMSFeedBags !== null) {
            getCompanySpecificLabels()
        }
    }, [userId, midWestPMSFeedBags, getCompanySpecificLabels])

    return (
        <>
            <Header />
            <Form id="order-form" className="order-form">
                <Col className='form-area'>
                    <Row className='form-column-row'>
                        <Row className='form-supplies-row'>
                            <SupplyCategories
                                supplies={supplies}
                                handleAddSuppliesForOrder={handleAddSuppliesForOrder}
                            />
                        </Row>
                        <Row className="sup-mssg-row">
                            <span className='wtr-sup-mssg' >
                                <b>Customer will be billed for supplies shipping costs</b>
                            </span>
                            <span className='wtr-sup-mssg' >
                                <b>Charges will be billed back to the customer when prepaid labels are used to ship samples to the labs</b>
                            </span>
                        </Row>
                        <Row className='form-shipping-row'>
                            <ShippingInfo
                                customerInformation={customerInformation}
                                handleUpdateAccountNumber={handleUpdateAccountNumber}
                                handleUpdateContactName={handleUpdateContactName}
                                handleUpdateEmailName={handleUpdateEmailName}
                                handleUpdateAddress={handleUpdateAddress}
                                handleUpdateCity={handleUpdateCity}
                                handleUpdateState={handleUpdateState}
                                handleUpdateZipCode={handleUpdateZipCode}
                                handleUpdatePhoneNumber={handleUpdatePhoneNumber}
                                handleUpdateLabLocation={handleUpdateLabLocation}
                                availableAccounts={availableAccounts}
                                accountAddress={accountAddress}
                                userAddress={userAddress}
                                handleRadioAddress={handleRadioAddress}
                                selectedAddress={selectedAddress}
                            />
                        </Row>
                    </Row>
                    <Row className='buttons-row'>
                        <Col xs={12} sm={12} md={12} lg={6} xl={6}>
                            {sendingOrder &&
                                <Button className='submit-btn' disabled>
                                    <span style={{ fontSize: "18px", color: "white" }}>Sending &nbsp;</span>
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        role="status"
                                        aria-hidden="true"
                                        style={{ height: "20px", width: "20px" }}
                                    />
                                </Button>
                            }
                            {!sendingOrder &&
                                <Button className='submit-btn' onClick={handleSubmit}>
                                    <span style={{ fontSize: "18px", color: "white" }}><b>Submit Order</b></span>
                                </Button>
                            }
                            <Button variant="outline-dark" className='cancel-btn' onClick={handleReset}>
                                <span style={{ fontSize: "18px" }}>Cancel Order</span>
                            </Button>
                        </Col>
                    </Row>
                </Col >
                <MissingDataModal
                    isOpen={showMissingDataModal}
                    setModalOpen={setShowMissingDataModal}
                    missingData={missingData}
                />
                <SuccessModal
                    isOpen={showSuccessModal}
                    setModalOpen={setShowSuccessModal}
                />
                <ErrorModal
                    isOpen={showErrorModal}
                    setModalOpen={setShowErrorModal}
                />
            </Form>
        </>
    )
}
export default App;
